<template>
  <!-- ローディングダイアログ(描画) -->
  <ItemDialog
    ref="DialogInitialLoading"
    :image-type="isTimeout ? 'alert' : 'loader'"
    :initial-open="true"
  >
    <template #content-area>
      <h2 v-if="!isTimeout">{{ $t("common.loading") }}</h2>
      <p v-else class="text-center">
        動作に時間がかかっています。<br />
        電波の良いところでもう一度お試しください。
      </p>
    </template>
    <template v-if="isTimeout" #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

import nativeHandlerService from "@/services/nativeHandler";
import { useStore } from "vuex";
export default {
  name: "DialogInitialLoading",
  props: {
    timeoutSeconds: {
      type: Number,
      required: false,
      default: 60000,
    },
    onClose: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const DialogInitialLoading = ref(null);
    const timer = ref(null);
    const isTimeout = ref(false);
    const store = useStore();
    const openDialog = () => {
      timer.value = setTimeout(timeout, props.timeoutSeconds);
      DialogInitialLoading.value.open();
    };

    const closeDialog = () => {
      isTimeout.value = false;
      clearTimeout(timer.value);
      // 基本はダイアログを閉じるでいいが、画面によっては個別の処理が必要
      if (props.onClose == null) {
        DialogInitialLoading.value.close();
        store.commit("common/setIsReloadComponent", true);
      } else {
        props.onClose();
      }
    };

    const timeout = () => {
      isTimeout.value = true;
    };

    onMounted(() => {
      setTimeout(timeout, props.timeoutSeconds);
    });

    return {
      DialogInitialLoading,
      isTimeout,
      openDialog,
      closeDialog,
    };
  },
};
</script>
